enum OrderType {
  RANK = 'rkd',
  PRICE = 'prd',
  DURATION = 'dud',
}

enum RecommendModal {
  NULL = 'NUL',
  Theme = 'Thm',
  Filter = 'Flt',
}

export { OrderType, RecommendModal };
